import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class AppOrganizationSettings {
    //Provide all the Application Configs here

    //don't Set Value here, set in app-metadata.handler.ts
    public currentOrganizationCd: string = 'METLIFE';

    public organizationLookup = [
        {
            organizationCd: 'MMS',
            name: 'Metamorphosys Technologies',
            logoname: 'logos/mmslogo.png',
            lightlogo: 'logo.light.png',
            darklogo: 'logo.dark.png',
            displayName: 'MetaMorphoSys',
            ownerMinAge: 0
        },
        {
            organizationCd: 'SOMPO',
            name: 'PT Sompo Insurance Indonesia',
            logoname: 'sompo.logo.png',
            lightlogo: 'sompo.logo.light.png',
            darklogo: 'sompo.logo.dark.png',
            displayName: 'Sompo Insurance',
            ownerMinAge: 18
        },
        {
            organizationCd: 'METLIFE',
            name: 'PNB MetLife India Insurance',
            logoname: 'logos/metlife.png',
            lightlogo: '',
            darklogo: '',
            displayName: 'PNB MetLife',
            ownerMinAge: 18
        }
    ]

    constructor() {
    }

    getOrganizationMetaData(){
        let orgMetaData = this.organizationLookup.filter(org => org.organizationCd === this.currentOrganizationCd)
        return orgMetaData[0];
    }
}
